import { useEffect, FunctionComponent } from 'react'

import Forbidden from 'components/shared/Forbidden'
import Error from 'components/shared/Error'
import { QAccordionNotFoundContainerProps } from 'redux/containers/components/accordion/QaAccordionNotFoundContainer'

const QaAccordionNotFound:FunctionComponent<QAccordionNotFoundContainerProps> = ({ setAccordionIsLoaded, isLimitedAccess, ...props }) => {
  useEffect(() => {
    setAccordionIsLoaded(true)
    return () => {
      setAccordionIsLoaded(false)
    }
  }, [])

  return isLimitedAccess ? <Forbidden /> : <Error {...props} />
}

export default QaAccordionNotFound
